import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { BRAND, NAV_LINKS } from '../data/mock';

import { img } from '../lib/img';

export default function Footer() {
  return (
    <footer className="bg-charcoal-deep text-ivory pt-24 pb-10 relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img loading="lazy" decoding="async"
              src={img(BRAND.logo, 1000)}
              alt="Mondaine Style"
              className="h-24 w-auto -ml-2"
            />
            <p className="font-serif text-2xl md:text-3xl mt-8 max-w-md leading-snug">
              Private styling for men who are <em className="italic-accent">ready to be seen</em>.
            </p>
            <p className="mt-6 text-sm text-ivory/60 max-w-md leading-relaxed">
              A founder-led studio in Bengaluru, by appointment only, with a deliberately limited number of private engagements each month.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] tracking-[0.28em] uppercase text-champagne mb-6">Navigate</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-ivory/80 hover:text-champagne transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/book-consultation" className="text-sm text-ivory/80 hover:text-champagne transition-colors">
                  Book Consultation
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] tracking-[0.28em] uppercase text-champagne mb-6">Studio</h4>
            <ul className="space-y-4 text-sm text-ivory/80">
              <li className="flex gap-3"><MapPin size={16} className="mt-[2px] text-champagne shrink-0" /> HSR, Bengaluru — by appointment</li>
              <li className="flex gap-3"><Phone size={16} className="mt-[2px] text-champagne shrink-0" /> <a href={`tel:${BRAND.phone.replace(/\s/g,'')}`} className="hover:text-champagne">{BRAND.phone}</a></li>
              <li className="flex gap-3"><Mail size={16} className="mt-[2px] text-champagne shrink-0" /> <a href={`mailto:${BRAND.email}`} className="hover:text-champagne">{BRAND.email}</a></li>
              <li className="flex gap-3"><Instagram size={16} className="mt-[2px] text-champagne shrink-0" /> @{BRAND.instagram}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-ivory/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-ivory/40 tracking-wider">
          <p>© {new Date().getFullYear()} Mondaine Style. All rights reserved.</p>
          <p className="tracking-[0.22em] uppercase">Crafted with intention in Bengaluru</p>
        </div>
      </div>

      <div aria-hidden className="absolute -top-32 -right-20 w-[420px] h-[420px] rounded-full opacity-[0.05]" style={{background:'radial-gradient(circle, #c9a961 0%, transparent 70%)'}} />
    </footer>
  );
}
